import axios from "axios";

export const strapiRemoteUri = "https://procheck-db.cr.baeren-lechtal.com";
export const apiRemoteUri = "https://procheck-api.cr.baeren-lechtal.com";

export const loginQuery = () => {
  const login = async (identifier, password) => {
    const res = await fetch(strapiRemoteUri + "/api/auth/local", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ identifier, password }),
    });

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error?.error?.message || "Login fehlgeschlagen");
    }

    const data = await res.json();
    localStorage.setItem("jwt", data.jwt);
    return data;
  };

  return { login };
};

export const registerQuery = () => {
  const register = async (username, email, password) => {
    const res = await fetch(strapiRemoteUri + "/api/auth/local/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, email, password }),
    });

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error?.error?.message || "Registrierung fehlgeschlagen");
    }

    const data = await res.json();
    // localStorage.setItem('jwt', data.jwt); // Do not auto-login after registration
    return data;
  };

  return { register };
};

export const fetchMemberships = async () => {
  const token = localStorage.getItem("jwt");
  if (!token) {
    throw new Error("No token found");
  }

  try {
    const response = await axios.get(apiRemoteUri + "/memberships", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch memberships:", error);
    throw error;
  }
};

export const fetchContainer = async (containerId) => {
  const token = localStorage.getItem("jwt");
  if (!token) {
    throw new Error("No token found");
  }

  try {
    const response = await axios.get(
      apiRemoteUri + "/container/" + containerId,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch container:", error);
    throw error;
  }
};

export const fetchChecksForGroup = async (groupId) => {
  const token = localStorage.getItem("jwt");
  if (!token) {
    throw new Error("No token found");
  }

  try {
    const response = await axios.get(apiRemoteUri + "/checks/" + groupId, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch checks:", error);
    throw error;
  }
};

export const fetchContainerWithCheck = async (containerId) => {
  const token = localStorage.getItem("jwt");
  if (!token) {
    throw new Error("No token found");
  }

  try {
    const response = await axios.get(
      apiRemoteUri + "/containerwithcheck/" + containerId,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch container:", error);
    throw error;
  }
};

export const fetchRootContainer = async (groupId) => {
  const token = localStorage.getItem("jwt");
  if (!token) {
    throw new Error("No token found");
  }

  try {
    const response = await axios.get(
      apiRemoteUri + "/rootcontainer/" + groupId,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch root container:", error);
    throw error;
  }
};

export const fetchMembershipsForGroup = async (groupId) => {
  const token = localStorage.getItem("jwt");
  if (!token) {
    throw new Error("No token found");
  }

  try {
    const response = await axios.get(apiRemoteUri + "/memberships/" + groupId, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch memberships:", error);
    throw error;
  }
};

export const fetchProducts = async () => {
  const token = localStorage.getItem("jwt");
  if (!token) {
    throw new Error("No token found");
  }

  try {
    // Using Strapi REST API to fetch producers with their items
    // This replaces the GraphQL query with REST API equivalent
    const response = await axios.get(`${strapiRemoteUri}/api/producers`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        populate: {
          logo: true,
          items: {
            populate: {
              category: true,
              variant: {
                populate: {
                  pic: true,
                },
              },
            },
          },
        },
      },
    });

    // Return the producers data from the response
    return response.data.data || [];
  } catch (error) {
    console.error("Failed to fetch products:", error);
    throw error;
  }
};

export const saveItem = async (product) => {
  try {
    const token = localStorage.getItem("jwt");
    const payload = {
      ...product,
      purchase_date: product.purchase_date?.toISOString().slice(0, 10), // Konvertierung
      produce_date: product.produce_date?.toISOString().slice(0, 10), // Konvertierung
    };

    const response = await fetch(apiRemoteUri + "/item/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Fehler beim Speichern:", errorData);
      throw new Error("Fehler beim speichern des Items.");
    }

    const responseData = await response.json();
    console.log("Erfolgreich gespeichert:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const saveContainer = async (container) => {
  try {
    const token = localStorage.getItem("jwt");

    const response = await fetch(apiRemoteUri + "/container/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(container),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Fehler beim Speichern:", errorData);
      throw new Error("Fehler beim speichern des Containers.");
    }

    const responseData = await response.json();
    console.log("Erfolgreich gespeichert:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const deleteItem = async (item) => {
  try {
    const token = localStorage.getItem("jwt");

    const response = await fetch(apiRemoteUri + "/entry/delete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(item),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Fehler beim Löschen:", errorData);
      throw new Error("Fehler beim löschen des Items.");
    }

    const responseData = await response.json();
    console.log("Erfolgreich gelöscht:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const deleteMembership = async (membership_id) => {
  try {
    const token = localStorage.getItem("jwt");
    const response = await fetch(apiRemoteUri + "/memberships/delete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(membership_id),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Fehler beim Speichern:", errorData);
      throw new Error("Fehler beim speichern des Memberships.");
    }

    const responseData = await response.json();
    console.log("Erfolgreich gespeichert:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const deleteCheck = async (check) => {
  console.log(check);
  try {
    const token = localStorage.getItem("jwt");
    const payload = {
      check_id: check.id,
      group_id: check.group_id,
    };
    console.log(payload);
    const response = await fetch(apiRemoteUri + "/check/delete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Fehler beim Löschen:", errorData);
      throw new Error("Fehler beim löschen des Checks.");
    }

    const responseData = await response.json();
    console.log("Erfolgreich gelöscht:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const deleteGroup = async (group_id) => {
  try {
    const token = localStorage.getItem("jwt");
    const response = await fetch(apiRemoteUri + "/group/delete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(group_id),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Fehler beim Löschen:", errorData);
      throw new Error("Fehler beim löschen des Memberships.");
    }

    const responseData = await response.json();
    console.log("Erfolgreich gelöscht:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const addMembership = async (membership) => {
  try {
    const token = localStorage.getItem("jwt");
    const response = await fetch(apiRemoteUri + "/memberships/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(membership),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Fehler beim Speichern:", errorData);
      throw new Error("Fehler beim speichern des Memberships.");
    }

    const responseData = await response.json();
    console.log("Erfolgreich gespeichert:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const addGroup = async (groupData) => {
  try {
    const token = localStorage.getItem("jwt");
    const user = JSON.parse(localStorage.getItem("user"));
    const payload = {
      ...groupData,
      user_id: user["documentId"],
    };
    const response = await fetch(apiRemoteUri + "/group/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Fehler beim Speichern:", errorData);
      throw new Error("Fehler beim speichern der Gruppe.");
    }

    const responseData = await response.json();
    console.log("Erfolgreich gespeichert:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const saveCheck = async (check) => {
  try {
    const token = localStorage.getItem("jwt");
    const payload = {
      ...check,
      check_date: check.check_date?.toISOString().slice(0, 10), // Konvertierung
      next_check_date: check.next_check_date?.toISOString().slice(0, 10), // Konvertierung
    };

    const response = await fetch(apiRemoteUri + "/check/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Fehler beim Speichern:", errorData);
      throw errorData;
    }

    const responseData = await response.json();
    console.log("Erfolgreich gespeichert:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

/**
 * Uploads an image to the Strapi v5 media library
 * and returns the uploaded file's ID and object
 *
 * @param {Blob|File} imageBlob - The image to upload
 * @param {Object} [options]
 * @param {string} [options.fileName="upload.png"]
 * @param {string} [options.jwt] - JWT (Users & Permissions plugin)
 * @param {string} [options.apiToken] - Strapi API Token
 * @returns {Promise<{ id: number, file: Object }>}
 */
export const uploadImageToStrapi = async (
  imageBlob,
  { fileName = "upload.png", jwt, apiToken } = {}
) => {
  const token = apiToken || jwt || localStorage.getItem("jwt");

  if (!token) {
    throw new Error("No token provided (jwt or apiToken required).");
  }

  const formData = new FormData();
  formData.append("files", imageBlob, fileName);

  const response = await fetch(`${strapiRemoteUri}/api/upload`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  let responseData;
  try {
    responseData = await response.json();
  } catch {
    throw new Error(`Upload failed with status ${response.status}.`);
  }

  if (!response.ok) {
    console.error("Fehler beim Hochladen:", responseData);
    const message =
      responseData?.error?.message ||
      responseData?.message ||
      "Fehler beim Hochladen.";
    throw new Error(message);
  }

  // Wir laden nur eine Datei → erste im Array nehmen
  const fileObj = Array.isArray(responseData) ? responseData[0] : responseData;

  return {
    id: fileObj.id, // für Media-Feld beim Collection-Eintrag
    file: fileObj, // falls du weitere Infos brauchst
  };
};
